'use client'

import { useEffect } from 'react'
import AuthManager from '@/lib/auth-manager'
import { useAuth } from '@/hooks/useAuth'

export function AuthManagerProvider({ children }: { children: React.ReactNode }) {
  const { session } = useAuth()

  useEffect(() => {
    // Initialize auth manager when session is available
    if (session) {
      const authManager = AuthManager.getInstance({
        refreshThreshold: 5 * 60, // Refresh 5 minutes before expiry
        checkInterval: 30 * 1000, // Check every 30 seconds
      })

      // Log initial token expiry for debugging
      authManager.getTimeUntilExpiry().then(seconds => {
        if (seconds) {
          console.log(`Token will expire in ${Math.floor(seconds / 60)} minutes`)
        }
      })
    }

    // Cleanup on unmount
    return () => {
      // Note: We don't destroy the singleton here as it should persist
    }
  }, [session])

  return <>{children}</>
}